var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [
              _vm._v(_vm._s(_vm.bizDepartFlag ? "部门" : "机构") + "导入文件")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("swb-file-upload", {
                attrs: {
                  fileGroup: "retailer.com.import",
                  onBeforeUpload: _vm.onBeforeUpload,
                  onProgress: _vm.onProgress,
                  onDone: _vm.onUploadDone,
                  multipleFile: false
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }),
          _vm._v(" "),
          _c("div", { staticClass: "form-value align-right" }, [
            _c(
              "a",
              { staticClass: "swb-btn-link", on: { click: _vm.downloadTmp } },
              [
                _vm._v(
                  "下载创建" +
                    _vm._s(_vm.bizDepartFlag ? "部门" : "机构") +
                    "模板"
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "deviceImpInfoTable",
          staticClass: "thin",
          staticStyle: { width: "100%", "font-size": "12px" },
          attrs: {
            data: _vm.comImpInfoList,
            border: "",
            "row-class-name": _vm.markSelectedRowClassName
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              width: "40",
              align: "center",
              fixed: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "机构名称",
              "class-name": "required",
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.name.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.name,
                              expression: "rows.row.name"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.name.errorMsg
                          },
                          domProps: { value: rows.row.name },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "name", $event.target.value)
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.name,
                              expression: "rows.row.name"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.name },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "name", $event.target.value)
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "no", label: "机构编号", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.no.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.no,
                              expression: "rows.row.no"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.no.errorMsg
                          },
                          domProps: { value: rows.row.no },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "no", $event.target.value)
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.no,
                              expression: "rows.row.no"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.no },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "no", $event.target.value)
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "code", label: "机构代码", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.code.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.code,
                              expression: "rows.row.code"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.code.errorMsg
                          },
                          domProps: { value: rows.row.code },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "code", $event.target.value)
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.code,
                              expression: "rows.row.code"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.code },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(rows.row, "code", $event.target.value)
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.bizDepartFlag
            ? _c("el-table-column", {
                attrs: { prop: "code", label: "机构二维码Code", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.orgType == 1
                          ? _c("span", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: rows.row.qrCode,
                                    expression: "rows.row.qrCode"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                attrs: { type: "text" },
                                domProps: { value: rows.row.qrCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      rows.row,
                                      "qrCode",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "orgType", label: "机构类型", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { disabled: "" },
                        on: {
                          change: function($event) {
                            _vm.orgTypeChangefunc(rows.row)
                          }
                        },
                        model: {
                          value: rows.row.orgType,
                          callback: function($$v) {
                            _vm.$set(rows.row, "orgType", $$v)
                          },
                          expression: "rows.row.orgType"
                        }
                      },
                      _vm._l(_vm.orgTypeList, function(item) {
                        return _c("el-option", {
                          attrs: { label: item.text, value: item.value }
                        })
                      })
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.bizDepartFlag
            ? _c("el-table-column", {
                attrs: {
                  prop: "bizUnitType",
                  label: "业务单元类型",
                  width: "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "el-select",
                          {
                            model: {
                              value: rows.row.bizUnitType,
                              callback: function($$v) {
                                _vm.$set(rows.row, "bizUnitType", $$v)
                              },
                              expression: "rows.row.bizUnitType"
                            }
                          },
                          _vm._l(_vm.bizUnitTypeList, function(item) {
                            return _c("el-option", {
                              attrs: { label: item.text, value: item.value }
                            })
                          })
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "comSysName", width: "150", label: "系统名称" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.comSysName.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.comSysName,
                              expression: "rows.row.comSysName"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.comSysName.errorMsg
                          },
                          domProps: { value: rows.row.comSysName },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "comSysName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.comSysName,
                              expression: "rows.row.comSysName"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.comSysName },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "comSysName",
                                $event.target.value
                              )
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "contactName", width: "150", label: "联系人姓名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.contactName.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactName,
                              expression: "rows.row.contactName"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.contactName.errorMsg
                          },
                          domProps: { value: rows.row.contactName },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactName,
                              expression: "rows.row.contactName"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.contactName },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactName",
                                $event.target.value
                              )
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "contactTel", width: "120", label: "联系电话" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.contactTel.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactTel,
                              expression: "rows.row.contactTel"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.contactTel.errorMsg
                          },
                          domProps: { value: rows.row.contactTel },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactTel",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactTel,
                              expression: "rows.row.contactTel"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.contactTel },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactTel",
                                $event.target.value
                              )
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "contactEmail", width: "200", label: "联系邮箱" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    !rows.row.validateInfo.contactEmail.validateOk
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactEmail,
                              expression: "rows.row.contactEmail"
                            }
                          ],
                          staticStyle: {
                            "background-color": "#edd28b",
                            width: "100%"
                          },
                          attrs: {
                            type: "text",
                            title: rows.row.validateInfo.contactEmail.errorMsg
                          },
                          domProps: { value: rows.row.contactEmail },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactEmail",
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.contactEmail,
                              expression: "rows.row.contactEmail"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.contactEmail },
                          on: {
                            change: _vm.commonChangeEvent,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "contactEmail",
                                $event.target.value
                              )
                            }
                          }
                        })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.bizUnitType == 1
            ? _c(
                "el-table-column",
                { attrs: { label: "机构标签", align: "center" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "tagId",
                      label: "设置",
                      width: "100",
                      "render-header": _vm.setTag
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: rows.row.tagId,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "tagId", $$v)
                                  },
                                  expression: "rows.row.tagId"
                                }
                              },
                              _vm._l(_vm.retailerShopTagList, function(item) {
                                return _c("el-option", {
                                  attrs: { label: item.name, value: item.id }
                                })
                              })
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.bizDepartFlag
            ? _c("el-table-column", {
                attrs: {
                  prop: "realComCode",
                  width: "120",
                  label: "实体公司编码"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.realComCode,
                              expression: "rows.row.realComCode"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.realComCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "realComCode",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.bizDepartFlag
            ? _c("el-table-column", {
                attrs: {
                  prop: "costCenterCode",
                  width: "120",
                  label: "成本中心编码"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.costCenterCode,
                              expression: "rows.row.costCenterCode"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.costCenterCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "costCenterCode",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.bizDepartFlag
            ? _c("el-table-column", {
                attrs: {
                  prop: "prftCenterCode",
                  width: "120",
                  label: "利润中心编码"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: rows.row.prftCenterCode,
                              expression: "rows.row.prftCenterCode"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: rows.row.prftCenterCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                rows.row,
                                "prftCenterCode",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bizAreaCode", width: "120", label: "经营区域编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rows.row.bizAreaCode,
                          expression: "rows.row.bizAreaCode"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { type: "text" },
                      domProps: { value: rows.row.bizAreaCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(rows.row, "bizAreaCode", $event.target.value)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "bizFormCode", width: "120", label: "经营业态编码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rows.row.bizFormCode,
                          expression: "rows.row.bizFormCode"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { type: "text" },
                      domProps: { value: rows.row.bizFormCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(rows.row, "bizFormCode", $event.target.value)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "mgmtSmlAreaCode",
              width: "120",
              label: "管理区域编码"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rows.row.mgmtSmlAreaCode,
                          expression: "rows.row.mgmtSmlAreaCode"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { type: "text" },
                      domProps: { value: rows.row.mgmtSmlAreaCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            rows.row,
                            "mgmtSmlAreaCode",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "indepenAcnt", width: "100", label: "独立核算" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: rows.row.indepenAcnt,
                          expression: "rows.row.indepenAcnt"
                        }
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(rows.row.indepenAcnt)
                          ? _vm._i(rows.row.indepenAcnt, null) > -1
                          : rows.row.indepenAcnt
                      },
                      on: {
                        change: function($event) {
                          var $$a = rows.row.indepenAcnt,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  rows.row,
                                  "indepenAcnt",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  rows.row,
                                  "indepenAcnt",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(rows.row, "indepenAcnt", $$c)
                          }
                        }
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "memo", label: "操作", align: "left", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.removeRow(rows.$index)
                          }
                        }
                      },
                      [_vm._v("移除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e886fe8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e886fe8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComImpCheck.vue
// module id = 2250
// module chunks = 0